<div class="d-flex align-items-center justify-content-end text-white text-end h-100 py-2 gloss-black point-container">
  <img [src]="'icons/claw-icon.svg' | contentAssetImage" alt="claw logo" class="me-1 icon"/>
  <span class="fw-bold">{{ pointsBalance$ | async }}</span>
</div>
